import { httpDelete, httpGet, httpPost, httpPut } from '../../../global/http-utils';

import { returnResponseIfOkOrSetGlobalErrorMessage } from '../../../global/api-utils';

export const getTenantLookupEntries = tenantId => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpGet(`tsi-multit/tenant-lookup/tenants/${tenantId}`),
    'An unexpected error occurred when getting tenant lookup entries'
  );
};

export const addTenantLookup = (tenantId, addTenantLookupRequest) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPost(`tsi-multit/tenant-lookup/tenants/${tenantId}`, addTenantLookupRequest),
    'An unexpected error occurred when adding tenant lookup'
  );
};

export const modifyTenantLookup = (tenantId, modifyTenantLookupRequest) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpPut(`tsi-multit/tenant-lookup/tenants/${tenantId}`, modifyTenantLookupRequest),
    'An unexpected error occurred when modifying tenant lookup'
  );
};

export const removeTenantLookup = (tenantId, tenantLookupInfo) => {
  return returnResponseIfOkOrSetGlobalErrorMessage(
    () => httpDelete(`tsi-multit/tenant-lookup/tenants/${tenantId}`, tenantLookupInfo),
    'An unexpected error occurred when deleting tenant lookup'
  );
};
